var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var MapConfigurationOverridesService = /** @class */ (function (_super) {
            __extends(MapConfigurationOverridesService, _super);
            function MapConfigurationOverridesService(injectedBreeze, $q, $http) {
                var _this = _super.call(this, injectedBreeze, $q) || this;
                _this.$http = $http;
                return _this;
            }
            MapConfigurationOverridesService.prototype.createMapConfigurationOverrides = function () {
                return this.createNewEntity("MapConfigurationOverride");
            };
            MapConfigurationOverridesService.prototype.createIncludedMapFunction = function () {
                return this.createNewEntity("IncludedMapFunction");
            };
            MapConfigurationOverridesService.prototype.createGisActionWorkflowOverride = function () {
                return this.createNewEntity("GisActionWorkflowOverride");
            };
            MapConfigurationOverridesService.prototype.createQueryGridOverride = function () {
                return this.createNewEntity("QueryGridOverride");
            };
            MapConfigurationOverridesService.prototype.createGisActionWorkflowGisFieldMap = function () {
                return this.createNewEntity("GisActionWorkflowGisFieldMap");
            };
            MapConfigurationOverridesService.prototype.createGisWherePlaceHolderValue = function () {
                return this.createNewEntity("GisWherePlaceHolderValue");
            };
            MapConfigurationOverridesService.prototype.getMapConfigurationOverrides = function (processConfigurationId) {
                var query = this.breezeModule.EntityQuery
                    .from("MapConfigurationOverrides")
                    .where('processConfiguration_id', '==', processConfigurationId)
                    .expand('includedMapFunctions.placeHolderValues, gisActionWorkflowOverrides.fieldMappings,' +
                    ' queryGridConfigurationOverrides.placeHolderValues, ' +
                    ' queryGridConfigurationOverrides.queryGridConfiguration.queryGridQueries.esriQueryConfiguration.wherePredicates, ' +
                    ' queryGridConfigurationOverrides.queryGridConfiguration.queryGridQueries.gisDatastoreQueryConfiguration.wherePredicates, ' +
                    ' gisActionWorkflowOverrides.gisActionWorkflowConfiguration.outputCollection.gisInputOutputs,' +
                    ' gisActionWorkflowOverrides.gisActionWorkflowConfiguration.gisActionBlocks.addFeaturesConfiguration.gisDatastore')
                    .orderBy("name");
                return this.executeQuery(query);
            };
            return MapConfigurationOverridesService;
        }(services.DataService));
        services.MapConfigurationOverridesService = MapConfigurationOverridesService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService('MapConfigurationOverridesService', ['breeze', '$q', '$http']);
